export const RANDOM_KEY = Math.random()
  .toString(36)
  .slice(2);
export const RANDOM_NUMBER = () => Math.floor(Math.random() * 10000);
export const RANDOM_STRING = () =>
  Math.random()
    .toString(36)
    .slice(-8);
